import { Box, Button } from "@mui/material";
import { Window, WindowActionsBar } from "@progress/kendo-react-dialogs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarIcon from '@mui/icons-material/Star';
import { Input, Switch } from "@progress/kendo-react-inputs";
import { useEffect, useState } from "react";
import getSetDataService from "../../../../shared/common-utilities/services/getSetDataService";
import AlertComponent from "../../../../shared/common-utilities/common/AlertComponent";
import dataStorageService from "../../../../shared/common-utilities/services/DataStorageService";

let service = getSetDataService();
let storageService = dataStorageService();

const SaveFilteredPopUp = (props) => {
    const { gridFlagVal, openModalFilter, setOpenModalFilter, treeViewData, reorderedCols, tempGridColumns, myGridDataState, columnChooser, filterCompValues, filterSortArr, isChild } = { ...props };

    const [selectedExistingView, setSelectedExistingView] = useState('Root');
    const [selectedExistingFilter, setSelectedExistingFilter] = useState('Root');
    const [newViewName, setNewViewName] = useState("");
    const [newFilterName, setNewFilterName] = useState("");
    const [favouriteView, setFavouriteView] = useState({ isFavouriteView: false, viewName: ''});
    const [favouriteFilter, setFavouriteFilter] = useState({ isFavouriteFilter: false, filterName: ''});
    const [filterDropdownVal, setFilterDropdownVal] = useState(['Root']);
    const [filterSwitch, setFilterSwitch] = useState(false);
    const [filterWindowPos, setFilterWindowPos] = useState({ left: 0, top:  0, width: 400, height: 270 });
    const [errorSnackbarMessage, setErrorSnackbarMessage] = useState('');
    const [isErrorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
    const [isVisibleWindow, setIsVisibleWindow] = useState(false);

    const initialSavedViewObj = { [gridFlagVal]: service.initialViewsObj }
    let treeViewDropDownData = treeViewData?.map(option => option.text);
    treeViewDropDownData?.push('Root');

    useEffect(() => {
        if (openModalFilter) {
            setIsVisibleWindow(true);
            service.setWindowInitialPosition(400, 270, setFilterWindowPos);
        }
    }, [openModalFilter])

    const onSaveViewData = (e) => {
        const tempViewName = e.target.value;
        const views = storageService.getLocalStorageData(gridFlagVal + 'Savedview');
        const updatedViews = views ? JSON.parse(views) : initialSavedViewObj;
        const defaultViewExist = updatedViews[gridFlagVal]?.savedViews?.filter(item => item.defaultView);
        const view = updatedViews[gridFlagVal]?.savedViews?.filter(item => item.viewName === tempViewName);
        let filterDropDown = [];
    
        if (defaultViewExist[0]?.viewName === tempViewName) {
          setFavouriteView({ isFavouriteView: true, viewName: tempViewName });
        } else {
          setFavouriteView({ isFavouriteView: false, viewName: tempViewName });
          setFavouriteFilter({ isFavouriteFilter: false, filterName: "" });
        }
    
        setSelectedExistingView(tempViewName);
        filterDropDown = view[0]?.subviews ? view[0].subviews?.map(item => item.viewName) : [];
        filterDropDown.push('Root');
    
        setFilterDropdownVal(filterDropDown);
        setSelectedExistingFilter('Root');
        setNewFilterName("");
    
        if (tempViewName !== 'Root') {
          setNewViewName(tempViewName);
        } else {
          setNewViewName('');
        }
    }
    
    const onSaveFilterData = (e) => {
        const tempFilterName = e.target.value;
        const views = storageService.getLocalStorageData(gridFlagVal + 'Savedview');
        const updatedViews = views ? JSON.parse(views) : initialSavedViewObj;
        const view = updatedViews[gridFlagVal]?.savedViews?.filter(item => item.viewName === selectedExistingView);
        const filterVal = view[0]?.subviews?.filter(item => item.isDefaultFilter);

        if (filterVal !== undefined && filterVal !== null) {
            if (filterVal[0]?.viewName === tempFilterName) {
                setFavouriteFilter({ isFavouriteFilter: true, filterName: tempFilterName });
            } else {
                setFavouriteFilter({ isFavouriteFilter: false, filterName: tempFilterName });
            }
        }

        setSelectedExistingFilter(tempFilterName);

        if (tempFilterName !== 'Root') {
            setNewFilterName(tempFilterName);
        } else {
            setNewFilterName('');
        }
    }

    const onSavefavouriteView = (value) => {
        setFavouriteView({ isFavouriteView: value, viewName: newViewName });
    }
    
    const onSavefavouriteFilter = (value) => {
        setFavouriteFilter({ isFavouriteFilter: value, filterName: newFilterName });
    }

    const onChangeFilterSwitch = (e) => {
        setFilterSwitch(e.target.value);
    }

    const closeModalFilter = () => {
        setOpenModalFilter(false);
        setNewFilterName("");
        setNewViewName("");
        setFilterSwitch(false);
        setFavouriteView({ isFavouriteView: false, viewName: "" });
        setFavouriteFilter({ isFavouriteFilter: false, filterName: "" });
    };

    const saveNewViewfilter = () => {
        if (_.isNil(newViewName) || newViewName?.trim() == "") {
          setErrorSnackbarMessage("Please provide a valid view name.");
          setErrorSnackbarOpen(true);
          return;
        }
        if (_.isNil(newFilterName) || newFilterName?.trim() == "" && filterSwitch) {
          setErrorSnackbarMessage("Please provide a valid filter name.");
          setErrorSnackbarOpen(true);
          return;
        }
    
        createAndEditSavedView();
    };

    const createAndEditSavedView = () => {
        const views = storageService.getLocalStorageData(gridFlagVal + 'Savedview');
        let updatedViews = views ? JSON.parse(views) : initialSavedViewObj;
        const isExistView = updatedViews[gridFlagVal].savedViews.filter(e => e.viewName === newViewName);
        const reorderedArr = reorderedCols?.length > 0 ? service.existingColumns(reorderedCols, tempGridColumns) : tempGridColumns;
        const viewDropDownVal = treeViewData?.map(item => item.text);
    
        if (viewDropDownVal?.includes(newViewName) && (selectedExistingView === "Root" || selectedExistingView !== newViewName)) {
          setErrorSnackbarMessage("This views is already exists!");
          setErrorSnackbarOpen(true);
          setNewViewName("");
          return null;
        }
        if (filterDropdownVal?.includes(newFilterName) && (selectedExistingFilter === "Root" || selectedExistingFilter !== newFilterName)) {
          setErrorSnackbarMessage("This filter name is already exists!");
          setErrorSnackbarOpen(true);
          setNewFilterName("");
          return null;
        }
    
        const obj = {
          viewName: newViewName,
          dataState: myGridDataState,
          columns: reorderedArr,
          group: columnChooser
        };

        const subviewObj = filterSwitch ? {
          viewName: newFilterName,
          filter: filterSortArr.filterArray?.length > 0 ? filterSortArr.filterArray : [],
          defaultFilter: filterCompValues
        } : null;
    
        // Check if creating a new view or editing an existing one
        if (selectedExistingView === "Root" || updatedViews?.length === 0) {
          // If creating a new view and there are filter options
          if (filterSwitch) {
            obj.subviews = subviewObj !== null ? [subviewObj] : [];
          }
          // If there are no existing views or if the selected view doesn't exist
          if (isExistView?.length <= 0) {
            updatedViews[gridFlagVal].savedViews.push(obj);
          }
        } else {
          // If editing an existing view
          const selectedViewIndex = updatedViews[gridFlagVal].savedViews.findIndex(view => view.viewName === selectedExistingView);
          if (selectedViewIndex !== -1) {
            const selectedView = updatedViews[gridFlagVal].savedViews[selectedViewIndex];
    
            selectedView.viewName = newViewName;
            selectedView.dataState = myGridDataState;
            selectedView.columns = reorderedArr;
            selectedView.group = columnChooser;
    
            selectedView.subviews = selectedView.subviews || [];  // Update or add subviews
    
            const existingSubviewIndex = selectedView.subviews.findIndex(subview => subview.viewName === selectedExistingFilter);
            if (existingSubviewIndex !== -1) {
              Object.assign(selectedView.subviews[existingSubviewIndex], subviewObj); // Update existing subview
            } else if (filterSwitch) {
              selectedView.subviews.push(subviewObj); // Add new subview
            } else {
              selectedView.subviews = [...selectedView.subviews];
            }
          }
        }
    
        updatedViews[gridFlagVal].savedViews = updatedViews[gridFlagVal].savedViews.map(view => {
          let updatedView = view;
    
          if (view.viewName !== newViewName) {
            if (favouriteView.isFavouriteView) {
              view.defaultView = false;
            }
          } else if (view.viewName === newViewName) {
            if (favouriteView.isFavouriteView) {
              view.defaultView = true;
            } else {
              view.defaultView = false;
            }
          }
    
          if (filterSwitch && (selectedExistingView === view.viewName || newViewName === view.viewName)) {
            updatedView.subviews = view?.subviews?.map(item => {
              if (item.viewName !== newFilterName) {
                if (favouriteFilter.isFavouriteFilter) {
                  return { ...item, isDefaultFilter: false };
                } else {
                  return { ...item };
                }
              } else if (item.viewName === newFilterName) {
                if (favouriteFilter.isFavouriteFilter) {
                  return { ...item, isDefaultFilter: true };
                } else {
                  return { ...item, isDefaultFilter: false };
                }
              }
            });
          }
    
          return updatedView;
        });
        
        storageService.setLocalStorageData(gridFlagVal + 'Savedview', JSON.stringify(updatedViews));
        
        setNewViewName("");
        setNewFilterName("");
        setFilterSwitch(false);
        setFavouriteView({ isFavouriteView: false, viewName: "" });
        setFavouriteFilter({ isFavouriteFilter: false, filterName: "" });
        closeModalFilter();

        props.sendDataToParent({ updatedViews: updatedViews, viewName: newViewName, filterName: newFilterName }, 'SaveFilteredData');
    }

    const handleErrorSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
        setErrorSnackbarOpen(false);
    };

    const onMoveWindow = (event) => {
        service.onMoveWindow(event, filterWindowPos, setFilterWindowPos);
    };

    const onResizeWindow = (event) => {
        service.onResizeWindow(event, setFilterWindowPos);
    }

    return (
        <>
          {(openModalFilter && isVisibleWindow) && <Window title={"Save Filtered Data"} className='kendo-popup' modal={true} initialWidth={400} initialHeight={270} minWidth={400} minHeight={270} onClose={closeModalFilter} left={filterWindowPos.left} top={filterWindowPos.top} onMove={onMoveWindow} onResize={onResizeWindow}>
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', paddingBottom: '10px' }}>
                    <Box sx={{ display: "flex", flexFlow: "column" }}>
                      <DropDownList
                          style={{
                            width: "120px",
                          }}
                          label="Save as:"
                          data={treeViewDropDownData}
                          value={selectedExistingView}
                          onChange={(e) => onSaveViewData(e)}
                      />
                    </Box>
                    <Box sx={{ display: "flex", flexFlow: "column", width: "100%" }}>
                        <Input
                          label="New View Name"
                          value={newViewName}
                          onChange={(e) => setNewViewName(e.target.value)}
                          name="newViewName"
                          autoComplete="off"
                        />
                    </Box>
                    
                    <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "end", alignItems: "baseline" }} onClick={() => onSavefavouriteView(!favouriteView.isFavouriteView)}>
                        {favouriteView.isFavouriteView ? <StarIcon color="warning" sx={{ mt: .5 }}/> : <StarBorderIcon />}
                    </Box>

                </Box>
                {!isChild && <Box sx={{ p: 0, pb: 2 }}>
                    <Switch
                        style={{ outlined: 0 }}
                        onLabel={""}
                        offLabel={""}
                        defaultChecked={filterSwitch}
                        onChange={onChangeFilterSwitch}
                    />
                </Box>}
                {filterSwitch && !isChild && <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between' }}>
                    <Box sx={{ display: "flex", flexFlow: "column" }}>
                      <DropDownList
                        label="Filter:"
                        style={{
                        width: "120px",
                        }}
                        data={filterDropdownVal}
                        value={selectedExistingFilter}
                        onChange={(e) => onSaveFilterData(e)}
                    />
                    </Box>
                    <Box sx={{ display: "flex", flexFlow: "column", width: "100%" }}>
                      <Input
                        label="Filter Name"
                        value={newFilterName}
                        onChange={(e) => setNewFilterName(e.target.value)}
                        name="newViewName"
                        autoComplete="off"
                      />
                    </Box>

                    <Box sx={{ display: "flex", flexFlow: "column", justifyContent: "end", alignItems: "baseline" }} onClick={() => onSavefavouriteFilter(!favouriteFilter.isFavouriteFilter)}>
                        {favouriteFilter.isFavouriteFilter ? <StarIcon color="warning" sx={{ mt: .5 }}/> : <StarBorderIcon />}
                    </Box>
                </Box>}

                <WindowActionsBar>
                    <Button variant="contained" onClick={saveNewViewfilter}>
                        Save
                    </Button>
                    <Button variant="outlined" onClick={closeModalFilter}>
                        Cancel
                    </Button>
                </WindowActionsBar>
            </Window>}

            <AlertComponent isErrorSnackbarOpen={isErrorSnackbarOpen} errorSnackbarMessage={errorSnackbarMessage} handleErrorSnackbarClose={handleErrorSnackbarClose} />
        </>
      )
}

export default SaveFilteredPopUp;